import type { SchemaExistingLoans } from '~/features/leadDetails/schemas/existingLoans.schema';
import { createRequiredContext } from '~/utils/createRequiredContext';

export type ItemId = `${keyof SchemaExistingLoans}.${number}`;

export type ExpandedItemContextType = {
    expandedItem: ItemId | null;
    setExpandedItem: (id: ItemId | null) => void;
    isExpanded: (id: ItemId) => boolean;
    toggleItem: (id: ItemId) => void;
    isExpandedItemDirty: () => boolean;
};

export const [useExpandedItem, ExpandedItemProviderComponent] =
    createRequiredContext<ExpandedItemContextType>('ExpandedItemContext');
